import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  pluck,
  filter,
  tap,
  switchMap,
  map,
  shareReplay,
} from 'rxjs/operators';
import * as LocalesActions from '../redux/actions/locales.actions';
import { Observable, combineLatest, of } from 'rxjs';
import { BackendService } from './backend.service';
import { RootState } from '../redux/reducers/shared.reducer';
import { State as LocalesState } from '../redux/reducers/locales.reducer';
import { getLocalesState } from '../redux/selectors';

/**
 * Subscribe to the public report$ property wherever you need to retrieve a report
 * Dispatch Update action if you need to fetch new value
 */
@Injectable({
  providedIn: 'root',
})
export class LocalesService {
  private readonly localesState$: Observable<any> = undefined;
  private fetchedLocales$ = this.localesState$.pipe(
    pluck('updateRequired'),
    filter(updateRequired => true === updateRequired),
    switchMap(_ => {
      try {
        return this.backedService.getLocales();
      } catch (error) {
        return of(error.message);
      }
    }),
    tap(response => {
      const payload =
        typeof response === 'string'
          ? { locales: [], errorMessage: response }
          : { locales: response, errorMessage: '' };
      this.store.dispatch(new LocalesActions.Receive(payload));
    })
  );
  /**
   * Subscription point to the fetched report
   * Emits once for every new subscriber
   */
  public locales$: Observable<LocalesState> = combineLatest([
    this.fetchedLocales$,
    this.localesState$]
  ).pipe(
    map(([_, state]) => state),
    shareReplay(1)
  );

  constructor(
    private store: Store<RootState>,
    private backedService: BackendService
  ) {
    this.localesState$ = this.store.pipe(select(getLocalesState));
  }
}
